interface CategoryPillProps {
  label: string;
  icon?: string;
  count?: number;
  active?: boolean;
  onClick?: () => void;
}

export default function CategoryPill({ label, icon, count, active, onClick }: CategoryPillProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2 font-label text-sm transition-colors ${
        active
          ? "border-primary-500 bg-primary-500 text-background-50"
          : "border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
      }`}
    >
      {icon ? <i className={`${icon} text-base`} aria-hidden="true"></i> : null}
      <span>{label}</span>
      {typeof count === "number" ? (
        <span
          className={`rounded-full px-1.5 py-0.5 text-xs ${
            active ? "bg-background-50/25 text-background-50" : "bg-background-100 text-foreground-500"
          }`}
        >
          {count}
        </span>
      ) : null}
    </button>
  );
}